<template>
  <div class="page-main">
    <van-nav-bar
      class="nav-bar"
      fixed
      title="我的收益"
      left-text="返回"
      left-arrow
      @click-left="goBack"
    >
      <div class="nav-bar-right" slot="right" @click="show=true">
        <van-icon name="warning-o" />
        <span class="text-right"> 如何提现</span>
      </div>
    </van-nav-bar>    
    <div class="content">
      <div class="user-info">
        <div class="user-info-header">
          <p class="text-gray text-small">可提现金额(元)</p>
          <p class="balance font-size-46 text-red">{{userInfo.Balance | money-parse}}</p>
        </div>
        <div class="user-info-footer row-flex-between">
          <div>
            <p class="text-gray">累计获得收益(元)</p>
            <p class="balance van-ellipsis">{{userInfo.CumulativeBalance | money-parse}}</p>
          </div>
          <div class="text-r">
            <p class="text-gray">冻结金额(元)</p>
            <p class="balance van-ellipsis text-green">{{userInfo.FrozenBalance | money-parse}}</p>
          </div>
        </div>
      </div>
      <MdScroll id="accountFlow" :url="url" :filterData="filterData" @getList="getList">
        <div class="content-msg">
          <div class="row-flex-between item" v-for="item in list" :key="item.Id">
            <div>
              <p class="van-ellipsis">{{item.Remark}}</p>
              <p class="text-gray text-small van-ellipsis">冻结金额 {{item.FrozenAmount | money-parse}}</p>
            </div>
            <div class="text-r">
              <p class="van-ellipsis" :class="{'text-red':item.Amount>0}">{{item.Amount | money-parse}}</p>
              <p class="text-small text-gray van-ellipsis">{{item.CreateTime | datetime-second-parse}}</p>
            </div>
          </div>
          <EmptyPosition v-show="!list.length"></EmptyPosition>
        </div>
      </MdScroll>
    </div> 
    <van-popup v-model="show" get-container="body">
      <withdraw @close="show=false"></withdraw> 
    </van-popup>      
  </div>
</template>

<script>
import MdScroll from '@/components/mdScroll/mdScroll'
import commonMix from '@/mixins/commonMix'
import EmptyPosition from '@/components/common/emptyPosition'
import Withdraw from '@/components/popUp/withdraw'
import { Cms } from '@/api'
export default {
  name: 'accountFlow',
  components: { MdScroll, EmptyPosition, Withdraw },
  mixins: [commonMix],
  data() {
    return {
      url: Cms.QueryOfUserByPage,
      filterData: {
        PageIndex: 1,
        PageSize: 10
      },
      list: [],
      userInfo: {},
      show: false
    }
  },
  created() {
    this.getUserAccount()
  },
  methods: {
    getList(list) {
      this.list = list
    },
    getUserAccount() {
      this.$api(Cms.GetUserAccount, {}).then(res => {
        this.userInfo = res
      })
    }
  }
}
</script>

<style lang="scss" scoped>
p {
  margin: 0 0 5px;
}
.font-size-46 {
  font-size: 46px;
}

.nav-bar {
  min-height: 46px;
  &-right {
    .text-right {
      color: #1989fa;
      vertical-align: middle;
    }
  }
}
.user-info {
  position: relative;
  height: 170px;
  padding: 10px 0;
  & :after {
    @include line;
  }
  &-header {
    margin-bottom: 20px;
    text-align: center;
  }
  &-footer {
    div {
      flex: 1;
      overflow: hidden;
      padding: 0 20px;
    }
  }
}

.content-msg {
  padding: 0 20px;
  font-size: $font-size-big;
  .item {
    padding: 20px 0 10px;
    border-bottom: 1px solid $gray;
    & > div {
      flex: 1;
      overflow: hidden;
    }
    & > div:nth-of-type(1) {
      margin-right: 20px;
    }
  }
}
.content {
  position: absolute;
  top: 46px;
  left: 0;
  right: 0;
  bottom: 0;
}
#accountFlow {
  top: 216px !important;
}
</style>

